import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const ADMIN_EMAILS = [
  'jstutzman@monadnockcyber.ai',
]

export default function Navbar() {
  const { user, logout } = useAuth()
  const isAdmin = user && ADMIN_EMAILS.includes(user.email)

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-dark-950/90 backdrop-blur-md border-b border-dark-800">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="text-xl font-bold tracking-tight">
          GINGERBREAD<span className="text-ginger-500">!</span><span className="text-ginger-500">PRIVACY</span>
        </Link>

        <div className="flex items-center gap-6">
          <a href="/#pricing" className="text-dark-300 hover:text-dark-100 text-sm hidden md:block">
            Pricing
          </a>
          <a href="/#how-it-works" className="text-dark-300 hover:text-dark-100 text-sm hidden md:block">
            How It Works
          </a>

          {user ? (
            <div className="flex items-center gap-4">
              <Link to="/dashboard" className="text-dark-300 hover:text-dark-100 text-sm">
                Dashboard
              </Link>
              {isAdmin && (
                <Link to="/admin" className="text-ginger-500 hover:text-ginger-400 text-sm font-medium">
                  Admin
                </Link>
              )}
              <button onClick={logout} className="btn btn-ghost text-sm">
                Logout
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/login" className="btn btn-ghost text-sm">
                Login
              </Link>
              <a href="#pricing" className="btn btn-primary text-sm">
                Check Your Exposure
              </a>
            </div>
          )}
        </div>
      </div>
    </nav>
  )
}
